import React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import { Navigate } from 'react-router-dom';

import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Home as HomeIcon } from '@vedmarket/ui-kit';
import { Cached as CachedIcon } from '@vedmarket/ui-kit';
import { ReactComponent as ErrorBoundaryIllustration } from 'assets/brand/ErrorBoundaryIllustration.svg';
import {ROUTES} from "../../../config/constants";
import {drawEyesCanvasInit, drawEyesCanvasRemove} from "../helpers";
import { leftEye, rightEye, customCoords} from './constants';

import './error-boundary.scss';

type Props = WithTranslation & {
  children: React.ReactNode
}

type State = {
  hasError: boolean;
  redirect: boolean;
};

class ErrorBoundaryComponent extends React.Component<Props, State> {

  state = {
    hasError: false,
    redirect: false
  };

  static getDerivedStateFromError() {
    // update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidMount(): void {
    drawEyesCanvasInit(50, 36, leftEye, rightEye, 'eyesErrorPage', customCoords);
  }

  componentWillUnmount() {
    drawEyesCanvasRemove(50, 36, leftEye, rightEye, 'eyesErrorPage', customCoords);
  }

  refreshPage = () => {
    window.location.reload();
    this.setState({ hasError: false });
  }


  goToTheMainPage = () => {
    this.setState({ hasError: false, redirect: true });
  };

  render() {

    const { t } = this.props;

    if (this.state.hasError) {
      return <>
        <div className='error-page-content'>
          <Typography variant='h4' sx={{ fontWeight: 500, marginBottom: 5 }}>
            {t('common__text__error')}
          </Typography>
          <canvas id='eyesErrorPage'></canvas>
          <ErrorBoundaryIllustration id='moleImage' className='error-page-content__image' />
          <Button
            variant='contained'
            startIcon={<CachedIcon />}
            sx={{ marginTop: 8, width: '312px' }}
            onClick={this.refreshPage}
          >
            {t('common__text__reloadPage')}
          </Button>
          <Button
            variant='contained'
            startIcon={<HomeIcon />}
            onClick={this.goToTheMainPage}
            sx={{ marginTop: 4, width: '312px' }}
          >
            {t('common__text__goToTheMainPage')}
          </Button>
        </div>
        {
          this.state.redirect && <Navigate to={ROUTES.CABINET} replace={true}/>
        }
      </>
    }

    return <>{this.props.children}</>;
  }
}


export default withTranslation()(ErrorBoundaryComponent);
